import common from "../common";

export default class Button extends P3.Button {
    constructor(buttonStates)
    {
        super(buttonStates);
        this.animate = true;
        this.animateIcon = true;
        //this.clickSound = 'sfx_btn_select';

        this.transitionAnimating = false;

        this.icon = this._icon;
    }

    hide()
    {
        this.scale.set(0);
    }

    appear(delay = 0)
    {
        console.log(delay);
        this.scale.set(0);
        this.transitionAnimating = true;
        TweenMax.to(this.scale, 0.3, {delay:delay, x:1, y:1, ease:Expo.easeOut, onComplete:() => {
            this.transitionAnimating = false;
        }});
    }

    disappear(delay = 0)
    {
        console.log(delay);
        this.scale.set(1);
        this.transitionAnimating = true;
        TweenMax.to(this.scale, 0.3, {delay:delay, x:0, y:0, ease:Back.easeIn, onComplete:() => {
            this.transitionAnimating = false;
        }});
    }

    onMouseClick(e)
    {
        if(!this.transitionAnimating)
            super.onMouseClick(e);
    }

    onMouseDown(e)
    {
        //common.audio.playSound(this.clickSound);
        if(!this.transitionAnimating)
            super.onMouseDown(e);
    }

    onMouseOver(e)
    {
        if(!this.transitionAnimating)
            super.onMouseOver(e);
    }

    onMouseOut(e)
    {
        if(!this.transitionAnimating)
            super.onMouseOut(e);
    }
}